import { AffiliateEnvironment } from "../../../interfaces/affiliate";
import {
  isAffiliateEnvironment,
  isAffiliateTestEnvironment,
} from "../../../utils/env";

export function verifiedAffiliateEnvironment(data?: AffiliateEnvironment) {
  if (!data || !isAffiliateEnvironment()) return false;
  return isAffiliateTestEnvironment()
    ? data.testnet_only === true &&
        (data.environment === undefined || data.environment === "testnet")
    : data.environment === "mainnet" && data.testnet_only === false;
}
export function assertAffiliateEnvironment(data: AffiliateEnvironment) {
  if (!verifiedAffiliateEnvironment(data))
    throw new Error(
      "Affiliate response does not match this admin environment."
    );
}
export function affiliateRequestID(data?: AffiliateEnvironment) {
  if (data?.command_receipt_policy === "expiring_v1") {
    const time = Date.parse(data.server_time || "");
    if (!Number.isFinite(time))
      throw new Error(
        "Refresh state to obtain server time before making changes."
      );
    const nonce = Array.from(
      window.crypto.getRandomValues(new Uint8Array(16)),
      (n) => n.toString(16).padStart(2, "0")
    ).join("");
    return `affv3:${Math.floor(time / 1000) + 3600}:${nonce}`;
  }
  if (data?.command_receipt_policy)
    throw new Error("This command policy requires a newer admin application.");
  const nonce = Array.from(
    window.crypto.getRandomValues(new Uint32Array(4)),
    (n) => n.toString(16)
  ).join("-");
  return `affiliate-admin-${nonce}`;
}
export const isTestOnlyAffiliateOperation = (operation: string) =>
  [
    "reset_testnet_cohort",
    "preview_testnet_cash_maturity",
    "mature_testnet_cash",
    "scenario",
    "user_demo",
  ].includes(operation);
